module.exports = __webpack_public_path__ + "assets/img/cpd-hours.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/cpd-hours.png
// module id = 1937
// module chunks = 0